import { render, staticRenderFns } from "./YourDigitalCoin.vue?vue&type=template&id=7bd07e46&scoped=true&"
import script from "./YourDigitalCoin.vue?vue&type=script&lang=ts&"
export * from "./YourDigitalCoin.vue?vue&type=script&lang=ts&"
import style0 from "./YourDigitalCoin.vue?vue&type=style&index=0&id=7bd07e46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd07e46",
  null
  
)

export default component.exports